import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import accessURL from "../../../../components/utils/superAccess";
import { Loader2, Building2 } from "lucide-react";


// Define the response type
interface CompanyResponse {
  status: string;
  code: number;
  name: string;
}

const Name: React.FC = () => {
  const { customID } = useParams<{ customID: string }>();
  const [companyName, setCompanyName] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        setLoading(true);
        const res = await accessURL.post<CompanyResponse>(
          `super-admin/getSingleCompany`,
          {
            customID,
          }
        );

        if (res.data && res.data.name) {
          setCompanyName(res.data.name);
        }

        setError(null);
      } catch (err) {
        console.error("Error fetching company data:", err);
        setError("Failed to load company information");
      } finally {
        setLoading(false);
      }
    };

    if (customID) {
      fetchCompanyData();
    }
  }, [customID]);

  return (
    <div className="p-6 max-w-4xl">
      {loading ? (
        <div className="flex items-center justify-center h-40">
          <Loader2 className="h-10 w-10 text-blue-500 animate-spin" />
        </div>
      ) : error ? (
        <div className="text-red-500 p-4 border border-red-200 rounded-lg bg-red-50">
          <p className="font-medium">{error}</p>
        </div>
      ) : (
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 shadow-lg rounded-lg overflow-hidden">
          <div className="p-8">
            <div className="bg-white rounded-lg p-6 shadow-sm">
              <h2 className="text-sm uppercase tracking-wider text-gray-500 mb-2">
                Company Name
              </h2>
              <h3 className="text-3xl font-bold text-indigo-700 capitalize mb-4">
                {companyName}
              </h3>

              <div className="h-1 w-20 bg-indigo-500 rounded mt-2"></div>
            </div>
          </div>
        </div>
      )}
   
    </div>
  );
};

export default Name;
